import { IApiService } from 'web_core_library';
import { IProductsPayload } from './types';

export function createSubscribeService() {
  let ApiService: IApiService;
  const getProducts = (coupon?: string) => {
    const params = coupon ? { coupon } : null;
    return ApiService.action<IProductsPayload>('web_products_onboarding_new', {
      method: 'get',
      params,
      urlParams: {
        project: 'nn',
      },
    });
  };

  const getProductsByIds = (ids: number[], coupon?: string) => {
    const params = coupon ? { coupon } : null;
    // coupons are currently not supported by backend for this endpoint
    return ApiService.action<IProductsPayload>('web_products_by_ids', {
      method: 'get',
      params,
      urlParams: {
        ids: ids.join(','),
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getProducts,
    getProductsByIds,
  };
  return service;
}

const SubscribeService = createSubscribeService();
export default SubscribeService;
